$('.login__input').on('focus', function(event) {
  var $input = $(event.currentTarget);
  $input.attr('placeholder', '');
  $input.animate({'padding-top': '12px'}, 200);
  $input.parent('.login__block').find('.login__active').animate(
      {'top': '-10px', 'opacity': '1'}, 200
  );
});

$('.login__input').on('blur', function(event) {
  var $input = $(event.currentTarget);
  $input.attr('placeholder', $input.attr('data-placeholder'));
  $input.animate({'padding-top': '0'}, 200);
  $input.parent('.login__block').find('.login__active').animate(
      {'top': '0px', 'opacity': '0'}, 200
  );
});

$('.navigation__bars').on('click', function() {
  'use strict';
  var $menu = $('.navigation__slidedown');
  if($menu.hasClass('open')) {
    $menu.animate({'left': '-100%'});
    $menu.removeClass('open');
  } else {
    $menu.addClass('open');
    $menu.animate({'left': '0'});
  }
});
